import { Box, BoxProps, ColorOptions, SpacerNew, TextNew, TextNewProps } from '@jfs/ui-new'
import { useCallback } from 'react'
import { Linking } from 'react-native'
import { Checkbox } from '../../comps/Checkbox'
import { useStores } from '../../data/store'
import { TERMS_AND_CONDITION } from '../FooterLink'

const ConsentCheckbox = () => {
  const { updateConsentCheckbox, consentCheckboxChecked } = useStores((root) => ({
    updateConsentCheckbox: root.user.updateConsentCheckbox,
    consentCheckboxChecked: root.user.consentCheckboxChecked,
  }))

  const onCheckboxPress = useCallback(() => {
    updateConsentCheckbox(!consentCheckboxChecked)
  }, [consentCheckboxChecked, updateConsentCheckbox])

  const onLinkPress = useCallback(() => {
    Linking.openURL(TERMS_AND_CONDITION).catch((err) => console.error('An error occurred', err))
  }, [])

  return (
    <Box {...styles.checkboxMainView}>
      <Checkbox
        disabled={false}
        isChecked={consentCheckboxChecked}
        onPress={() => onCheckboxPress()}
        size={24}
        color={'BLUE_SHADE_PRIMARY' as ColorOptions}
      />
      <SpacerNew size={8} direction="horizontal" />
      <Box {...styles.agreementContainer}>
        <TextNew {...styles.agreementText} testID="consent-checkbox-text" title={'I agree to JioPay Business '} />
        <Box onPress={onLinkPress} underlayColor="LIGHTEST_GREY">
          <TextNew {...styles.agreementTextBlue} testID="terms-and-condition" title={'Terms & Conditions'} />
        </Box>
      </Box>
    </Box>
  )
}

export { ConsentCheckbox }

const styles = {
  checkboxMainView: {
    flexDirection: 'row',
  } as BoxProps,
  agreementText: {
    fontSize: 12,
    color: 'BLACK_75',
    lineHeight: 18,
    opacity: 0.65,
    fontFamily: 'jiotype-medium',
  } as TextNewProps,
  agreementTextBlue: {
    fontSize: 12,
    color: 'BLUE_SHADE_PRIMARY',
    lineHeight: 18,
    fontFamily: 'jiotype-medium',
  } as TextNewProps,
  agreementContainer: {
    justify: 'center',
    flexDirection: 'row',
    alignItems: 'center',
  } as BoxProps,
}
